import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_FAILURE,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_SUCCESS,

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_SUCCESS,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_FAILURE,

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_SUCCESS,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_FAILURE,

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_SUCCESS,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_FAILURE,

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CLEAR,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_FILTER,

    InstitutionItemTemplateCategoryAction
} from '../actions/institutionItemTemplateCategories';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IInstitutionItemTemplateCategoryState {
    formData: Dtos.InstitutionItemTemplateCategory | Dtos.InstitutionItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.InstitutionItemTemplateCategory[];
}

const initialState: IInstitutionItemTemplateCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: IInstitutionItemTemplateCategoryState, _isLoading: boolean): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IInstitutionItemTemplateCategoryState,
    formData: Dtos.InstitutionItemTemplateCategory | Dtos.InstitutionItemTemplateCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IInstitutionItemTemplateCategoryState, formFilter: IFormFilter): IInstitutionItemTemplateCategoryState {

    const institutionItemTemplateCategories: Dtos.InstitutionItemTemplateCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = institutionItemTemplateCategories ? institutionItemTemplateCategories.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: IInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IInstitutionItemTemplateCategoryState, propertiesToClear?: string[]): IInstitutionItemTemplateCategoryState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IInstitutionItemTemplateCategoryState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IInstitutionItemTemplateCategoryState, _isSaving: boolean): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IInstitutionItemTemplateCategoryState,
    formData: Dtos.InstitutionItemTemplateCategory | Dtos.InstitutionItemTemplateCategory[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IInstitutionItemTemplateCategoryState, _isCreating: boolean): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IInstitutionItemTemplateCategoryState,
    formData: Dtos.InstitutionItemTemplateCategory,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IInstitutionItemTemplateCategoryState, _isValidating: boolean): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IInstitutionItemTemplateCategoryState,
    formData: Dtos.InstitutionItemTemplateCategory,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IInstitutionItemTemplateCategoryState, responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCategoryState {
    const newState: IInstitutionItemTemplateCategoryState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const InstitutionItemTemplateCategoryReducer: Reducer<IInstitutionItemTemplateCategoryState> = (state: IInstitutionItemTemplateCategoryState = initialState, action: InstitutionItemTemplateCategoryAction) => {
    switch (action.type) {
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD:
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE:
            return saving(state, true);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE:
            return creating(state, true);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE:
            return validating(state, true);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default InstitutionItemTemplateCategoryReducer;